const blCampaignIsArabic = document.documentElement.lang === 'ar';
const blCampaignDigits = (value) =>
  blCampaignIsArabic ? String(value).replace(/[0-9]/g, (digit) => '٠١٢٣٤٥٦٧٨٩'[digit]) : String(value);

function setBottlesCampaignCopyState(isActive) {
  document.querySelectorAll('[data-campaign-active-copy]').forEach((node) => {
    node.hidden = !isActive;
  });
  document.querySelectorAll('[data-campaign-ended-copy]').forEach((node) => {
    node.hidden = isActive;
  });
  document.querySelectorAll('[data-campaign-live]').forEach((node) => {
    node.hidden = !isActive;
  });
  document.querySelectorAll('[data-campaign-expired]').forEach((node) => {
    node.hidden = isActive;
  });
}

class BottlesCountdown extends HTMLElement {
  connectedCallback() {
    this.endAt = new Date(this.dataset.endAt || '');
    if (Number.isNaN(this.endAt.getTime())) return;
    this.tick = this.tick.bind(this);
    this.tick();
    this.timer = window.setInterval(this.tick, 1000);
  }

  disconnectedCallback() {
    if (this.timer) window.clearInterval(this.timer);
  }

  tick() {
    const distance = this.endAt.getTime() - Date.now();
    if (distance <= 0) {
      setBottlesCampaignCopyState(false);
      if (this.timer) window.clearInterval(this.timer);
      this.classList.add('is-ended');
      this.querySelectorAll('[data-days], [data-hours], [data-minutes], [data-seconds]').forEach((node) => {
        node.hidden = true;
      });
      const ended = this.querySelector('.bl-countdown__ended');
      if (ended) ended.hidden = false;
      return;
    }

    setBottlesCampaignCopyState(true);

    const values = {
      days: Math.floor(distance / 86400000),
      hours: Math.floor((distance % 86400000) / 3600000),
      minutes: Math.floor((distance % 3600000) / 60000),
      seconds: Math.floor((distance % 60000) / 1000),
    };

    Object.entries(values).forEach(([key, value]) => {
      const node = this.querySelector(`[data-${key}]`);
      if (node) node.textContent = blCampaignDigits(String(value).padStart(2, '0'));
    });
  }
}

if (!customElements.get('bottles-countdown')) {
  customElements.define('bottles-countdown', BottlesCountdown);
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-copy-code]');
  if (!button) return;
  const code = button.dataset.copyCode;
  if (!code) return;

  try {
    await navigator.clipboard.writeText(code);
    button.classList.add('is-copied');
    const label = button.querySelector('small');
    if (label) {
      const original = label.textContent;
      label.textContent = blCampaignIsArabic ? 'تم النسخ' : 'Copied';
      window.setTimeout(() => {
        label.textContent = original;
        button.classList.remove('is-copied');
      }, 1600);
    }
  } catch (error) {
    window.prompt(blCampaignIsArabic ? 'انسخ كود الخصم' : 'Copy discount code', code);
  }
});

const campaignEnd = document.querySelector('bottles-countdown[data-end-at]')?.dataset.endAt;
if (campaignEnd) {
  const parsedCampaignEnd = new Date(campaignEnd);
  if (!Number.isNaN(parsedCampaignEnd.getTime())) {
    setBottlesCampaignCopyState(Date.now() < parsedCampaignEnd.getTime());
  }
}
